var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.232 14.118C23.2164 13.2028 23.1228 12.2772 22.9356 11.3776C22.5508 9.52122 21.5524 8.10681 19.5504 7.56601C18.2452 7.21241 16.9296 7.23321 15.6244 7.57641C14.6468 7.83121 13.8616 8.36162 13.2064 9.21442C13.2064 8.98562 13.2064 8.10682 13.2064 7.46722H8.37561C8.37561 11.5856 8.37561 17.9972 8.37561 21.9492H13.2064C13.2064 19.7704 13.196 16.5464 13.2116 14.5496C13.222 13.6916 13.4196 12.8596 13.976 12.1576C14.5584 11.4192 15.3644 11.2216 16.264 11.3412C17.1428 11.4556 17.7668 11.9548 17.98 12.7816C18.1516 13.4472 18.2504 14.144 18.2608 14.8304C18.2868 16.7284 18.2504 19.968 18.24 21.9544H23.2476C23.2528 19.6456 23.2684 16.2552 23.232 14.118Z",
    fill: "#535F79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45959 7.46201C1.45959 9.57841 1.45959 12.8076 1.45959 14.7212C1.45959 16.6608 1.45959 19.8224 1.45959 21.9492H6.34239C6.34759 18.018 6.34759 11.518 6.34239 7.46721H1.45959V7.46201Z",
    fill: "#535F79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91406 0.26001C2.20846 0.26001 0.840855 1.58081 0.856455 3.21881C0.872055 4.84121 2.20846 6.14641 3.86726 6.15161C5.56766 6.15161 6.91446 4.86721 6.92486 3.23441C6.93006 1.59121 5.58326 0.26001 3.91406 0.26001Z",
    fill: "#535F79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.7184e8b57dfa08fdc8c214308ae95c64.svg";
export { ForwardRef as ReactComponent };